import React from 'react';

const { Provider: PostServiceProvider, Consumer: PostServiceConsumer } = React.createContext();

export { PostServiceProvider, PostServiceConsumer };
